module.exports = __webpack_public_path__ + "static/media/main-background-desktop.f5cd3304.png";